export default __webpack_public_path__ + "static/media/icon1.e66f252b.png";